(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track   = document.getElementById('rv-track');
  var prev    = document.getElementById('rv-prev');
  var next    = document.getElementById('rv-next');
  if (!track || !prev || !next) return;

  var current = 0;

  function visible() {
    var w = track.parentElement.offsetWidth;
    if (w < 500) return 1;
    if (w < 900) return 2;
    return 3;
  }

  function total() { return track.children.length; }
  function max()   { return Math.max(0, total() - visible()); }

  function goTo(n) {
    current = Math.max(0, Math.min(n, max()));
    var gap  = 16;
    var cw   = track.children[0] ? track.children[0].offsetWidth + gap : 0;
    track.style.transform = 'translateX(-' + (current * cw) + 'px)';
    prev.disabled = current === 0;
    next.disabled = current >= max();
  }

  prev.addEventListener('click', function () { goTo(current - 1); });
  next.addEventListener('click', function () { goTo(current + 1); });

  /* Swipe */
  var sx = 0;
  track.addEventListener('touchstart', function (e) { sx = e.changedTouches[0].screenX; }, { passive: true });
  track.addEventListener('touchend',   function (e) {
    var diff = sx - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
  }, { passive: true });

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () { goTo(Math.min(current, max())); }, 150);
  });

  goTo(0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFeatureStrip(sectionId) {
    var track = document.getElementById('fs-track-' + sectionId);
    var dotsContainer = document.getElementById('fs-dots-' + sectionId);
    if (!track || !dotsContainer) return;

    var dots = dotsContainer.querySelectorAll('.fs-dot');
    var slides = track.querySelectorAll('.fs-mobile__slide');
    var total = slides.length;
    var current = 0;
    var autoplayTimer = null;
    var isUserInteracting = false;
    var interactionTimeout = null;

    function setActive(index) {
      current = index;
      dots.forEach(function (d, i) {
        d.classList.toggle('fs-dot--active', i === index);
      });
    }

    function goToSlide(index) {
      var next = (index + total) % total;
      track.scrollTo({ left: track.offsetWidth * next, behavior: 'smooth' });
      setActive(next);
    }

    function startAutoplay() {
  stopAutoplay();
  var sectionEl = document.getElementById('fs-section-' + sectionId);
  var speed = parseInt(sectionEl.getAttribute('data-autoplay-speed')) || 3000;
  autoplayTimer = setInterval(function () {
    if (!isUserInteracting) {
      goToSlide(current + 1);
    }
  }, speed);
}

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    // Pause autoplay while user is touching/swiping
    track.addEventListener('touchstart', function () {
      isUserInteracting = true;
      clearTimeout(interactionTimeout);
    }, { passive: true });

    track.addEventListener('touchend', function () {
      // Resume autoplay 3s after user stops touching
      interactionTimeout = setTimeout(function () {
        isUserInteracting = false;
      }, 3000);
    }, { passive: true });

    // Scroll → update dots
    track.addEventListener('scroll', function () {
      var slideWidth = track.offsetWidth;
      var index = Math.round(track.scrollLeft / slideWidth);
      if (index !== current) setActive(index);
    }, { passive: true });

    // Dot click → scroll to slide + pause briefly
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        isUserInteracting = true;
        clearTimeout(interactionTimeout);
        goToSlide(i);
        interactionTimeout = setTimeout(function () {
          isUserInteracting = false;
        }, 3000);
      });
    });

    // Pause autoplay when tab is hidden, resume when visible
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    startAutoplay();
  }

  // Init all on page load
  document.querySelectorAll('[id^="fs-section-"]').forEach(function (el) {
    var id = el.id.replace('fs-section-', '');
    initFeatureStrip(id);
  });

  // Shopify theme editor re-init
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[id^="fs-section-"]');
    if (el) {
      var id = el.id.replace('fs-section-', '');
      initFeatureStrip(id);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTabs(section) {
    var buttons = section.querySelectorAll('.pdp-tab-btn');
    var panels  = section.querySelectorAll('.pdp-panel');

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        // Reset all
        buttons.forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.classList.remove('pdp-panel--active');
        });
        // Activate clicked
        btn.classList.add('active');
        btn.setAttribute('aria-selected', 'true');
        if (panels[i]) panels[i].classList.add('pdp-panel--active');
      });

      // Arrow-key keyboard nav
      btn.addEventListener('keydown', function (e) {
        var cur  = i;
        var next = -1;
        if (e.key === 'ArrowRight') next = (cur + 1) % buttons.length;
        if (e.key === 'ArrowLeft')  next = (cur - 1 + buttons.length) % buttons.length;
        if (next >= 0) { buttons[next].focus(); buttons[next].click(); }
      });
    });
  }

  document.querySelectorAll('.pdp-tabs-section').forEach(initTabs);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.pdp-tabs-section');
    if (s) initTabs(s);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
